import { pl } from './pl';
import { en } from './en';
import { de } from './de';

const DICTIONARY = {
  pl: pl,
  en: en,
  de: de
};
let available_languages = ['pl', 'en', 'de'];

export function T(key) {
  let lang_to_set = 'pl';
  if (
    typeof current_language === 'undefined' ||
    !available_languages.indexOf(current_language) >= 0
  ) {
    lang_to_set = 'pl';
  } else {
    lang_to_set = current_language;
  }

  let translation = DICTIONARY[lang_to_set][key];

  if (translation === undefined) {
    return 'Translation missing';
  } else {
    return translation;
  }
}



// WEBPACK FOOTER //
// ./common/locale/translate.js